import React from 'react';
import classnames from 'classnames';
import styles from '../styles/MobileBottomNav.module.scss';
import { MarketScanIcon } from '../../../components/svgs/MarketScanIcon';
import { DashboardIconNew } from '../../../components/svgs/DashboardIconNew';
import { HomeIcon } from '../../../components/svgs/HomeIcon';
import {
  MARKET_SCAN_ROUTE,
  HOME_ROUTE,
  ADD_POLICY_ROUTE,
  DASHBOARD_ROUTE,
} from 'constants/routes';
import { IUser } from 'types';
import { Plus } from 'react-feather';
import { Link, useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';

interface IMobileBottomNav {
  className?: string;
  items?: IMenuItems[];
  user?: IUser;
}

interface IMenuItems {
  route: string;
  icon?: React.ComponentType<any>;
  label: string;
  className?: string;
  exact?: boolean;
  active?: boolean;
  getIcon?(props: any): JSX.Element;
  onClick?(): void;
}

interface IMenuTabProps {
  item: IMenuItems;
  user?: IUser;
  pathname: string;
}

const DEFAULT_ITEMS: IMenuItems[] = [
  {
    route: HOME_ROUTE,
    exact: true,
    icon: HomeIcon,
    label: 'Home',
    className: styles.home,
  },
  {
    route: ADD_POLICY_ROUTE,
    exact: true,
    icon: Plus,
    label: 'Add Policy',
    className: styles.plus,
  },
  {
    route: MARKET_SCAN_ROUTE,
    icon: MarketScanIcon,
    label: 'Market Scan',
    className: styles.marketScan,
  },
  {
    route: DASHBOARD_ROUTE,
    icon: DashboardIconNew,
    label: 'Dashboard',
    className: styles.dashboard,
  },
];

const MenuTab: React.FC<IMenuTabProps> = ({ item, user, pathname }) => {
  const {
    active,
    route,
    icon: MenuIcon,
    label,
    className,
    exact,
    getIcon,
    onClick,
  } = item;
  const isRoute =
    active || (exact ? pathname === route : pathname.includes(route));
  const icon = getIcon
    ? getIcon({ user, isRoute })
    : MenuIcon && (
        <MenuIcon className={classnames(isRoute && styles.active, className)} />
      );

  return (
    <Link
      to={route || '#'}
      onClick={onClick}
      className={classnames(
        styles.mobileNavItem,
        isRoute && styles.active,
        className,
      )}
    >
      <div
        className={classnames(styles.activeBar, isRoute && styles.active)}
      ></div>
      <div
        className={classnames(styles.mobileNavIcon, isRoute && styles.active)}
      >
        {icon}
      </div>
      <div
        className={classnames(styles.mobileNavText, isRoute && styles.active)}
      >
        {label}
      </div>
    </Link>
  );
};

const MobileBottomNav: React.FC<IMobileBottomNav> = ({
  className,
  user,
  items = DEFAULT_ITEMS,
}) => {
  const location = useLocation();
  const el = document.getElementById('mobile-bottom-nav');

  return (
    el &&
    createPortal(
      <div className={classnames(styles.mobileNavContainer, className)}>
        {items.map((item) => (
          <MenuTab
            key={item.label}
            item={item}
            user={user}
            pathname={location.pathname}
          />
        ))}
      </div>,
      el,
    )
  );
};

export default MobileBottomNav;
